import { Navigate } from 'react-router-dom';

const Protected = ({ isAdmin, role, children }) => {
  if (!isAdmin) {
    return <Navigate to={`/auth/${role}`} replace />;
  }
  return children;
};
export default Protected;
